import moment from 'moment';
import { containerContents, containerTypes, importExcelContainerTypes } from '../../const';
import { importExcel } from '../../utils';

const getValidRows = (rows: any[]) => {
  return rows.map((row) => {
    let isValid = true;

    const containerNumber = row[0].slice(0, 11);
    if (containerNumber.length !== 11) {
      isValid = false;
    } else {
      row[0] = containerNumber;
    }

    const containerType =
      importExcelContainerTypes[row[1] as keyof typeof importExcelContainerTypes];
    if (!containerType) {
      isValid = false;
    } else {
      row[1] = containerType;
    }

    const completedAt = moment(row[2], 'DD.MM.YYYY');
    if (!completedAt.isValid()) {
      isValid = false;
    } else {
      row[2] = completedAt;
    }

    return isValid ? row : { '0': '', '1': '20DC', '2': null };
  });
};

export const handleImportExcelClick = ({
  setCount,
  setContainerNumber,
  setContainerType,
  setCompletedAt,
  setCondition,
  setContainerContent,
}: any) => {
  let rows1: any[] = [];
  let rows2: any[] = [];
  let rows3: any[] = [];
  let rows4: any[] = [];
  let rows5: any[] = [];

  importExcel((rows: any[]) => {
    const validRows = getValidRows(rows);

    rows1 = validRows.map((row) => row[0]);
    rows2 = validRows.map((row) => row[1]);
    rows3 = validRows.map((row) => row[2]);
    rows4 = validRows.map(() => '');
    rows5 = validRows.map(() => containerContents[0].value);

    if (!rows1.length) {
      setCount(1);
      setContainerNumber(['']);
      setContainerType([containerTypes[0].value]);
      setCompletedAt([null]);
      setCondition(['']);
      setContainerContent([containerContents[0].value]);
      return;
    }

    setCount(rows1.length || 0);
    setContainerNumber(rows1);
    setContainerType(rows2);
    setCompletedAt(rows3);
    setCondition(rows4);
    setContainerContent(rows5);
  });
};
